import React from 'react';
import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import {
    ContactSection, BadgeListSection, SocialSection,
    AboutSection, ExperienceSection, EducationSection, ReferencesSection,
} from './PdfSections';

const HEADING = '#2465AB';

const styles = StyleSheet.create({
    page: { flexDirection: 'row', padding: 0, fontSize: 10, fontFamily: 'Helvetica' },
    left: { width: '35%', backgroundColor: '#2465AB', padding: 20, color: '#ffffff' },
    right: { width: '65%', padding: 20 },
    name: { fontSize: 18, fontWeight: 'bold', marginBottom: 4 },
    title: { fontSize: 11, marginBottom: 12, color: '#ffffff' },
    whiteText: { color: '#ffffff' },
});

function Template5Pdf(props) {
    const {
        name, about, email, address, phone, title,
        technicalSkills, languages, softSkills,
        linkedinURL, twitterURL, githubURL, websiteURL,
        educationData, jobData, showSocial, referenceData,
    } = props;

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap>
                <View style={styles.left}>
                    <Text style={styles.title}>{title}</Text>
                    <ContactSection email={email} phone={phone} address={address} />
                    <BadgeListSection title="Professional Skills" items={technicalSkills} />
                    <BadgeListSection title="Soft Skills" items={softSkills} />
                    <BadgeListSection title="Languages Known" items={languages} />
                    <SocialSection linkedinURL={linkedinURL} twitterURL={twitterURL} githubURL={githubURL} websiteURL={websiteURL} showSocial={showSocial} />
                </View>
                <View style={styles.right}>
                    <Text style={styles.name}>{name}</Text>
                    <AboutSection about={about} headingColor={HEADING} />
                    <ExperienceSection jobData={jobData} headingColor={HEADING} />
                    <EducationSection educationData={educationData} headingColor={HEADING} />
                    <ReferencesSection referenceData={referenceData} headingColor={HEADING} />
                </View>
            </Page>
        </Document>
    );
}

export default Template5Pdf;